import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="HoOme" />
    <div style={{ paddingTop: "120px" }}>oferta here</div>
  </Layout>
)

export default IndexPage
